import sectionMenuClasses from '../section-menu/SectionMenu.module.scss';

const MenuItem = ({ href, label }) => {
  return (
    <a
      className={`title title__bold title__small ${sectionMenuClasses['item-link']}`}
      href={href}>
      {label}
    </a>
  );
};

export default MenuItem;
